import { createReducer, on } from "@ngrx/store";
import { LoadingState } from "@core/models";
import { PrintKioskActions } from "./print-kiosks.actions";
import { initialState, printKiosksAdapter } from "./print-kiosks.state";

export const printKiosksReducer = createReducer(
  initialState,

  on(PrintKioskActions.reset, () => ({ ...initialState })),

  on(PrintKioskActions.add, (state) => ({
    ...state,
    callState: LoadingState.LOADING,
  })),
  on(PrintKioskActions.addSuccess, (state, { printKiosk }) => ({
    ...printKiosksAdapter.addOne(printKiosk, state),
    callState: LoadingState.LOADED,
  })),
  on(PrintKioskActions.addFailure, (state, { error }) => ({
    ...state,
    callState: { errorMsg: (error as Error)?.message ?? 'Unknown error' },
  })),

  on(PrintKioskActions.remove, (state) => ({
    ...state,
    callState: LoadingState.LOADING,
  })),
  on(PrintKioskActions.removeSuccess, (state, { id }) => ({
    ...printKiosksAdapter.removeOne(id, state),
    callState: LoadingState.LOADED,
  })),
  on(PrintKioskActions.removeFailure, (state, { error }) => ({
    ...state,
    callState: { errorMsg: (error as Error)?.message ?? 'Unknown error' },
  })),

  on(PrintKioskActions.linkToPrinter, (state) => ({
    ...state,
    callState: LoadingState.LOADING,
  })),
  on(PrintKioskActions.linkToPrinterSuccess, (state) => ({
    ...state,
    callState: LoadingState.LOADED,
  })),
  on(PrintKioskActions.linkToPrinterFailure, (state, { error }) => ({
    ...state,
    callState: { errorMsg: (error as Error)?.message ?? 'Unknown error' },
  })),

  on(PrintKioskActions.load, (state) => ({
    ...state,
    callState: LoadingState.LOADING,
  })),
  on(PrintKioskActions.loadSuccess, (state, { printKiosks }) => ({
    ...printKiosksAdapter.setAll(printKiosks, state),
    callState: LoadingState.LOADED,
  })),
  on(PrintKioskActions.loadFailure, (state, { error }) => ({
    ...state,
    callState: { errorMsg: (error as Error)?.message ?? 'Unknown error' },
  }))
);
